export type PaymentConfiguration = {
  payment_limits?: Record<string, number>;
  allowed_payment_methods?: string[];
};

export type AccountBalanceConfiguration = {
  aging_date_basis: string; // "Invoiced Date" | "Invoice Due Date"
  aging_buckets: number[];
};

export type TabConfiguration = {
  show_account_balance?: boolean;
  show_invoices?: boolean;
  show_delivery_notes?: boolean;
};

export type InvitationEmailConfiguration = {
  reply_to_email?: string;
  show_user_name?: boolean;
};

export const PAYMENT_METHODS = ['CreditCard', 'ACH'] as const;
export type PaymentMethod = (typeof PAYMENT_METHODS)[number];
export const DEFAULT_PAYMENT_LIMITS: Record<PaymentMethod, number> = {
  ACH: 500000,
  CreditCard: 9999999999.99,
};

export const AGING_DATE_BASIS = ['INVOICE_DATE', 'DUE_DATE'] as const;
export type AgingDateBasis = (typeof AGING_DATE_BASIS)[number];
export const DEFAULT_AGING_DATE_BASIS: AgingDateBasis = 'DUE_DATE';
export const DEFAULT_AGING_BUCKETS = [30, 60, 90];

export type BaseApiLegalCorporationConfig = {
  id: number;
  legalCorporationID: string;
  contactEmail: string;
  subscriptionRequestEmail: string;
  isPaymentEnabled: boolean;
  isPaymentCutoffEnabled: boolean;
  surchargePercentage?: number | string;
  maxAllowedDaysToPay?: number;
  reconciliationEmails?: string | null;
  isInvoiceNotificationEnabled?: boolean;
  paymentConfiguration?: PaymentConfiguration | null;
  accountBalanceConfiguration?: AccountBalanceConfiguration | null;
  tabConfiguration?: TabConfiguration | null;
  invitationEmailConfiguration?: InvitationEmailConfiguration | null;
};

export type UpdateSettingsRequestBody = {
  legalCorporationId: string;
  contactEmail: string;
  subscriptionRequestEmail: string;
  isPaymentEnabled: boolean;
  surchargePercentage: number;
  isPaymentCutoffEnabled: boolean;
  maxAllowedDaysToPay: number;
  reconciliationEmails: string[];
  allowedPaymentMethods: PaymentMethod[];
  paymentLimits: Partial<Record<PaymentMethod, number>>;
  agingBuckets: number[];
  agingDateBasis: AgingDateBasis;
  showInvoices: boolean;
  showDeliveryNotes: boolean;
  showAccountBalance: boolean;
  isInvoiceNotificationEnabled: boolean;
  invitationReplyToEmail: string;
  invitationShowUserName: boolean;
};
